import type { BadgeProps } from "@bowfast/ui/components/badge";
import type { OrgRole } from "~/graphql/generated";
import type { TabKey } from "./crew.types";

export const ROLE_CONFIG: Record<OrgRole, { label: string; variant: BadgeProps["variant"] }> = {
  OWNER: { label: "Owner", variant: "charter" },
  SKIPPER: { label: "Skipper", variant: "confirmed" },
  ADMIN: { label: "Admin", variant: "planning" },
  CREW: { label: "Crew", variant: "secondary" },
  INSTRUCTOR: { label: "Instructor", variant: "pending" },
  STUDENT: { label: "Student", variant: "secondary" },
  OBSERVER: { label: "Observer", variant: "secondary" },
};

// Presence is derived at render time from crewMemberships — no custom enum needed
export const AT_SEA_CONFIG = { label: "At sea", dot: "bg-shallow-500", ring: "ring-shallow-500/30" };
export const AVAILABLE_CONFIG = { label: "Available", dot: "bg-shallow-400", ring: "ring-shallow-400/30" };

export const TABS: { key: TabKey; label: string }[] = [
  { key: "all", label: "All crew" },
  { key: "at-sea", label: "At sea" },
  { key: "skippers", label: "Skippers" },
  { key: "instructors", label: "Instructors" },
  { key: "crew", label: "Crew" },
];
